import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { AppStore } from "../../redux/store";
import { IconAlertCircle } from "@tabler/icons-react";

const FailPay = () => {
  const { country } = useSelector((store: AppStore) => store.country);
  const navigate = useNavigate();

  const handleRetry = () => {
    navigate(-1); // Volver atrás
  };

  const handleGoToMarket = () => {
    if (typeof window !== "undefined") {
      window.open(
        `/${country}/venta/casas-y-apartamentos/proyectos`,
        "_self"
      );
    }
  };

  return (
    <section className="h-screen flex justify-center items-center bg-[#FFEBEE]">
      <div className="container mx-auto">
        <div className="max-w-2xl mx-auto w-full lg:px-0 py-10">
          {/* ✅ LOGO */}
          <img
            className="w-48 mx-auto"
            src="https://storage.googleapis.com/assets-us-east4-propilatam/website-assets/propi-web/v2/logo-propi.svg"
            alt="Propi Logo"
          />

          {/* ✅ ICON ERROR */}
          {/*
          <div className="flex justify-center mt-6">
            <div className="bg-red-100 rounded-full p-4">
              <IconAlertCircle
                size={48}
                color="#d32f2f"
                strokeWidth={1.5}
              />
            </div>
          </div>
          */}

          {/* ✅ TITLE */}
          <h1 className="text-center text-[#212121] text-3xl font-semibold mt-6">
            Tu pago no fue procesado
          </h1>

          {/* ✅ SUBTITLE */}
          <p className="text-center font-medium text-[#757575] mt-2">
            Ocurrió un problema al procesar tu pago. Por favor, intenta nuevamente.
          </p>

          {/* ✅ BUTTONS */}
          <div className="flex flex-col gap-3 mt-8 max-w-sm mx-auto">
            {/* Botón Reintentar */}
        
            
       {/*
<button
  onClick={handleRetry}
  className="py-3 px-6 bg-[#212121] text-center font-medium rounded-xl text-white hover:bg-[#1a1a1a] transition-colors w-full"
>
  Reintentar pago
</button>
*/}
            

            {/* Botón Ver más proyectos */}
            <button
              onClick={handleGoToMarket}
              className="py-3 px-6 bg-white text-center font-medium rounded-xl text-[#212121] border border-[#212121] hover:bg-gray-50 transition-colors w-full"
            >
              Ver más proyectos
            </button>
          </div>

          {/* ✅ HELP TEXT */}
{/*
          <div className="mt-8 bg-amber-50 border border-amber-200 rounded-lg p-4 max-w-sm mx-auto">
            <p className="text-sm text-amber-800 text-center">
              ¿Continúas teniendo problemas?{" "}
              <a
                href="mailto:soporte@propi.com"
                className="font-semibold text-amber-900 hover:underline"
              >
                Contacta con soporte
              </a>
            </p>
          </div>
*/}
        </div>
      </div>
    </section>
  );
};

export default FailPay;